<template>
  <div>
    <el-dialog
      title="详情"
      :visible.sync="boxDetailShow"
      width="50%"
      @close="toggleBoxDetailShow"
    >
      <div class="boxDetailDiv" v-show="boxDetailShow">
        <!-- <el-button
          icon="el-icon-close"
          v-show="boxDetailShow"
          circle
          id="bdetailClose"
          @click="toggleBoxDetailShow"
        ></el-button> -->
        <el-tabs v-model="activeName">
          <!-- @tab-click="tabClick" -->
          <el-tab-pane label="详情" name="xq">
            <div class="text item">名称:{{ formData.mapDrawName }}</div>
            <div class="text item">风险等级:{{ formData.riskLevel }}</div>
            <div class="text item">区域名称:{{ formData.name }}</div>
            <div class="text item">固定资产总值:{{ formData.fixedValue }}</div>
            <div class="text item">危险化学品:</div>
            <div class="text item">火灾危险性等级:</div>
          </el-tab-pane>
          <el-tab-pane label="工艺报警" name="gybz">
            <el-table :data="findSirenTimelyDataList" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="tagId" label="tagID" />
              <el-table-column align="center" prop="tagName" label="名称"/>
              <el-table-column align="center" label="地图" width="160">
                <template slot-scope="scope">
                  <el-button size="small" v-if="scope.row.showInBubble === 0"  type="success" @click="checkShowGYBJMap(scope.row.pointId,1)">显示</el-button>
                  <el-button size="small" v-if="scope.row.showInBubble === 1"  type="warning" @click="checkShowGYBJMap(scope.row.pointId,0)">隐藏</el-button>
                  <el-button size="small" type="primary" @click="drawerDevicePoint(scope.row.pointId)">定位</el-button>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="monitoringContent" label="检查内容"/>
              <el-table-column align="center" prop="value" label="数值"/>
              <el-table-column align="center" prop="unit" label="单位"/>
              <el-table-column align="center" prop="location" label="位置"/>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="承诺卡" name="cnk">
            <div class="text item">承诺卡名称:{{ promise.name }}</div>
            <div class="text item">承诺卡编号:{{ promise.number }}</div>
            <div class="text item">部门:{{ promise.depName }}</div>
            <div class="text item">部门领导:{{ promise.leaderName }}</div>
            <div class="text item">岗位:{{ promise.jobName }}</div>
            <div class="text item">承诺事项:{{ promise.content }}</div>
            <div class="text item">承诺时间:{{ promise.commitmentDate }}</div>
            <div class="text item">附件:<el-link type="primary" @click="downloadBtn(promise.fileUrl, promise.fileName)">
              {{ promise.fileName }}</el-link></div>
          </el-tab-pane>
          <el-tab-pane label="应急卡" name="yjk">
            <div class="text item">应急卡名称:{{ emergency.name }}</div>
            <div class="text item">应急卡编号:{{ emergency.number }}</div>
            <div class="text item">部门:{{ emergency.depName }}</div>
            <div class="text item">部门领导:{{ emergency.leaderName }}</div>
            <div class="text item">岗位:{{ emergency.jobName }}</div>
            <div class="text item">工艺附件:<el-link type="primary" @click="downloadBtn(emergency.craftFileUrl, emergency.craftFileName)">
              {{ emergency.craftFileName }}
            </el-link></div>
            <div class="text item">步骤说明:{{ emergency.procedureExp }}</div>
            <div class="text item">事故风险_事故后果:{{ emergency.accidentRisk }}</div>
            <div class="text item">发生场所:{{ emergency.place }}</div>
            <div class="text item">危害描述:{{ emergency.harmDescribe }}</div>
            <div class="text item">应急处理政策:{{ emergency.emergencyProcessing }}</div>
            <div class="text item">内部应急电话:{{ emergency.interiorEmergencyCall }}</div>
            <div class="text item">外部应急电话:{{ emergency.externalEmergencyCall }}</div>
            <div class="text item">附件:<el-link type="primary" @click="downloadBtn(emergency.fileUrl, emergency.fileName)">
              {{ emergency.fileName }}
            </el-link></div>
          </el-tab-pane>
          <el-tab-pane label="应知卡" name="yzk">
            <div class="text item">应知卡名称:{{ should.name }}</div>
            <div class="text item">应知卡编号:{{ should.number }}</div>
            <div class="text item">部门:{{ should.depName }}</div>
            <div class="text item">主要有害因素:{{ should.primaryHarmfulFactor }}</div>
            <div class="text item">易导致事故风险:{{ should.accidentLiability }}</div>
            <div class="text item">风险等级:<span v-if="should.riskLevel">{{ riskLevelArr[should.riskLevel - 1].label }}</span></div>
            <div class="text item">风险管控措施:{{ should.riskControlMeasures }}</div>
            <div class="text item">应急处置对策:{{ should.emergencyProcessing }}</div>
            <div class="text item">安全指示标志:<span v-if="should.safetyWarningLabel">{{ saftyArr[should.safetyWarningLabel - 1].label }}</span></div>
            <div class="text item">附件:<el-link type="primary" @click="downloadBtn(should.fileUrl, should.fileName)">
              {{ should.fileName }}
            </el-link></div>
          </el-tab-pane>
          <el-tab-pane label="安全风险分级管控清单" name="pxjl">
            <el-table :data="aqfxData" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="riskName" label="风险管控名" />
              <el-table-column align="center" label="工程技术措施">
                <template slot-scope="scope">
                  <span>{{ scope.row.measure.technicalMeasure }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="管理措施">
                <template slot-scope="scope">
                  <span>{{ scope.row.measure.managementMeasure }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="培训教育措施">
                <template slot-scope="scope">
                  <span>{{ scope.row.measure.trainingMeasure }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="个体防护措施">
                <template slot-scope="scope">
                  <span>{{ scope.row.measure.personalFenceMeasure }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="应急处置措施" >
                <template slot-scope="scope">
                  <span>{{ scope.row.measure.emergencyMeasure }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="responsibleEmpName" label="责任人" />
              <el-table-column align="center" prop="controlEmpName" label="管控人" />
              <el-table-column align="center" label="风险等级">
                <template slot-scope="scope">
                  <div class="tableText">
                    <div v-if="scope.row.controlLevel === 0" class="hight">重大风险</div>
                    <div v-if="scope.row.controlLevel === 1" class="origin">较大风险</div>
                    <div v-if="scope.row.controlLevel === 2" class="middle">一般风险</div>
                    <div v-if="scope.row.controlLevel === 3" class="blueS">低风险</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="管控层级">
                <template slot-scope="scope">
                  <div class="tableText">
                    <div v-if="scope.row.controlHierarchy === 0">公司级</div>
                    <div v-if="scope.row.controlHierarchy === 1">车间级</div>
                    <div v-if="scope.row.controlHierarchy === 2">班组级</div>
                    <div v-if="scope.row.controlHierarchy === 3">岗位级</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="危险（有害）因素排查辨识清单" name="grzs">
            <el-table :data="wxysData" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="project" label="检查项目作业步骤" />
              <el-table-column align="center" prop="standardOrIncident" label="检查标准/风险源或曾在事件" />
              <el-table-column align="center" prop="riskFactor" label="风险要素" />
              <el-table-column align="center" prop="riskDescription" label="不符合标准状况/可能发生事故描述" />
              <el-table-column align="center" prop="accidentType" label="易发事故类型" />
              <el-table-column align="center" prop="consequence" label="危害/后果" />
              <el-table-column align="center" label="管控状态">
                <template slot-scope="scope">
                  <div class="tableText">
                    <span v-if="scope.row.isControl === 0" class="middle">否</span>
                    <span v-if="scope.row.isControl === 1" class="low">是</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="作业记录" name="ksjl">
            <el-table :data="zyjlData" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="no" label="编号">
              </el-table-column>
              <el-table-column align="center" prop="name" label="名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="actualStarttime"
                label="实际时间"

              >
              </el-table-column>
              <el-table-column align="center" prop="status" label="状态">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="巡检记录" name="xjjl">
            <el-table :data="xjjlData" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="number" label="编号">
              </el-table-column>
              <el-table-column align="center" prop="name" label="名称">
              </el-table-column>
              <el-table-column align="center" prop="errorStatus" label="异常状态">
              </el-table-column>
              <el-table-column
                align="center"
                prop="planStartTime"
                label="计划时间"

              >
              </el-table-column>
              <el-table-column align="center" prop="startTime" label="实际时间">
              </el-table-column>
              <el-table-column align="center" prop="status" label="状态">
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="报警记录" name="bjjl">
            <el-table :data="bjjlData" style="width: 100%" :header-cell-style="tableTouStyle" height="400">
              <el-table-column align="center" prop="tagId" label="tagID">
              </el-table-column>
              <el-table-column align="center" prop="tagName" label="采集点名称">
              </el-table-column>
              <el-table-column align="center" prop="location" label="报警位置">
              </el-table-column>
              <el-table-column align="center" label="报警类型">
                <template slot-scope="scope">
                  <div class="tableText">
                    <div v-if="scope.row.alertType === 4" class="hight">低低</div>
                    <div v-if="scope.row.alertType === 3" class="middle">低报</div>
                    <div v-if="scope.row.alertType === 2" class="middle">高报</div>
                    <div v-if="scope.row.alertType === 1" class="hight">高高</div>
                    <!-- <div v-if="scope.row.overType === 3">正常</div> -->
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="level" label="优先级">
                <template slot-scope="scope">
                  <div class="tableText">
                    <div v-if="scope.row.level === 1" class="middle">中</div>
                    <div v-if="scope.row.level === 0" class="low">低</div>
                    <div v-if="scope.row.level === 2" class="hight">高</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="value" label="报警值">
              </el-table-column>
              <el-table-column align="center" prop="collectionTime" label="报警时间">
              </el-table-column>
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <div class="tableText">
                    <div v-if="scope.row.status === 0" class="high">待核实</div>
                    <div v-if="scope.row.status === 1" class="middle">待处置</div>
                    <div v-if="scope.row.status === 2" class="middle">待复查</div>
                    <div v-if="scope.row.status === 3" class="low">完成</div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- <list-page ref="page" :total="totalNum" @chileByCurrentPage="chileByCurrentPage($event)" /> -->
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import ListPage from './list_main_page'
import {
  getInfo,
  getRiskclassification,
  getHarmfulfactorsinvestigation,
  getWorkPermit,
  getInspectionrecord,
  // getChannelrecord,
  getChannelrecordNew,
  getFindSirenTimelyDataNew,
  // updateChannelAlarmsShowOrHide
  updateChannelAlarmsShowOrHideNew,
  markLongitudeAndLatitude
} from "@/api/BoxData.js";
import MapUtil from "@/views/control/map/util/mapUtil";
import cesiumUtil from "@/utils/cesiumUtils";
import {updateLagLat} from "@/api/worker";
import ECesium from "@/views/control/map/util/ECesium";
export default {
  components: {
    ListPage
  },
  props: {},
  data() {
    return {
      // 表格头部样式
      tableTouStyle: {
        background: '#f1f1f1',
        color: '#000',
        'font-size': '14px',
        'text-align': 'center'
      },
      totalNum: null,
      form: {
        dangerInfoId: '',
        curPage: 1,
        limit: 100000,
      },

      bjjlData: [],
      xjjlData: [],
      zyjlData: [],
      aqfxData: [],
      wxysData: [],
      activeName: "xq",
      findSirenTimelyDataList: [],
      formData: {
        name: undefined,
        mapDrawName: undefined,
        riskLevel: undefined,
        fixedValue: undefined,
        cameraList: [],
        promiseCardEntity: { content: "" },
        shouldKnowCardEntity: { content: "" },
        emergencyVo: {},
        promiseCardVo: {},
        shouldKnowCardVo: {}
      },
      // 三卡的数据
      emergency: {},
      promise: {},
      should: {},
      // 风险等级数组
      riskLevelArr: [
        { label: "一级", value: 1 },
        { label: "二级", value: 2 },
        { label: "三级", value: 3 },
        { label: "四级", value: 4 }
      ],
      // 安全指示标示数组
      saftyArr: [
        { label: '指示标志', value: 1 },
        { label: '警示作业安全警示标志', value: 2 },
        { label: '逃生避难警示标志', value: 3 },
        { label: '风向警示标志', value: 4 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      boxId: "boxId",
      boxDetailShow: "boxDetailShow",
    }),
  },
  watch: {
    boxDetailShow(val) {
      if (val) {
        this.init();
      }
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 子组件传给父组件的分页参数
    chileByCurrentPage(val) {
      this.$nextTick(function() {
        this.form.curPage = val
      })
    },
    // tabClick(tab, event) {
    //   this.form.curPage = 1
    //   this.form.limit = 50
    // },
    ...mapActions({
      toggleBoxDetailShow: "toggleBoxDetailShow",
    }),
    init() {
      this.getDetail();
    },
    checkShowGYBJMap(id,value){
      let self=this;
      alert("处理显示"+id+" value:"+value);
      // updateChannelAlarmsShowOrHide(id,value).then((res) => {
      updateChannelAlarmsShowOrHideNew(id,value).then((res) => {
        // 工艺报警
        let formData = new FormData();
        formData.append('dangerInfoId', this.form.dangerInfoId);
        formData.append('curPage', 1);
        formData.append('limit', 1000000);
        getFindSirenTimelyDataNew(formData).then((res) => {
          if (res.data.data) {
            self.findSirenTimelyDataList = res.data.data
          }
        });
      });

    },
    /**
     * 地图打点设备位置
     * @param id
     */
    drawerDevicePoint(id){
      this.$parent.$refs.boxer.drawerDevicePoint(id);//打开列表
    },

    getDetail() {
      getInfo(this.boxId).then((res) => {
        this.formData = res.data.data;
        this.form.dangerInfoId = res.data.data.id
        // 管控
        getRiskclassification(this.form.dangerInfoId, this.form.curPage, this.form.limit).then((res) => {
          this.aqfxData = res.data.data
        });
        // 辨识
        getHarmfulfactorsinvestigation(this.form.dangerInfoId, this.form.curPage, this.form.limit).then((res) => {
          this.wxysData = res.data.data;
        });
        // 报警记录
        // getChannelrecord(this.form).then((res) => {
        getChannelrecordNew(this.form).then((res) => {
          // this.totalNum = res.data.pageTotal
          this.bjjlData = res.data.data;
        });
        // 工艺报警
        let formData = new FormData();
        formData.append('dangerInfoId', this.form.dangerInfoId);
        formData.append('curPage', 1);
        formData.append('limit', 1000000);
        getFindSirenTimelyDataNew(formData).then((res) => {
          if (res.data.data) {
            this.findSirenTimelyDataList = res.data.data
          }
        });
        // 三卡的信息
        if(res.data.data.emergencyVo) {
          this.emergency = res.data.data.emergencyVo
        }else{
          this.emergency = {}
        }
        if(res.data.data.promiseCardVo) {
          this.promise = res.data.data.promiseCardVo
        }else{
          this.promise = {}
        }
        if(res.data.data.shouldKnowCardVo) {
          this.should = res.data.data.shouldKnowCardVo
        }else{
          this.should = {}
        }
      });
      getWorkPermit(this.boxId).then((res) => {
        this.zyjlData = res.data.data;
      });
      getInspectionrecord(this.boxId).then((res) => {
        this.xjjlData = res.data.data;
      });
    },
    // 下载文件
    downloadBtn(url, name) {
      downLoadDocument(url,name)
    }
  },
};
</script>
<style scoped>
/deep/ .el-dialog {
  margin-top: 200px !important;
  height: 60%;
  background: #ffffff;
  border-radius: 2px;
}
/deep/ .el-dialog__header {
  height: 40px;
  background: #f5f5f5;
  padding: 0;
  text-align: center;
  line-height: 40px;
}
/deep/ .el-dialog__body{
  height: calc(100% - 40px);
}
/deep/ .el-dialog__title {
  line-height: 40px;
  color: #333333;
  font-size: 16px;
  font-weight: 500;
}
/deep/ .el-dialog__headerbtn {
  position: absolute;
  top: 0px;
  right: 10px;
}
.boxDetailDiv {
  height: 100%;
}
/deep/ .el-tabs{
  height: 100%;
}
/deep/ .el-tabs__content{
  height: calc(100% - 55px);
  overflow-y: scroll
}
.tableText{
  display: flex;
  justify-content: center;
  padding: 5;
}
.hight{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: red;
  color: white;
}
.low{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: green;
  color: white;
}
.middle{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: yellow;
  color: #333333;
}
.origin{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: orange;
}
.blueS{
  width: 60px;
  height: 30px;
  line-height: 30px;
  background: blue;
}
.text {
  font-size: 14px;
}
.item {
  margin-bottom: 18px;
}
#bdetailClose {
  position: absolute;
  top: -20px;
  right: -20px;
  z-index: 1003;
}
</style>
